<div class="inbuilt-stat-card">
  <!-- <h3 class="card-title">{{ cardTitle }}</h3> -->
  <div class="loading-indicator" *ngIf="loading">
    <mat-spinner diameter="36"></mat-spinner>
  </div>

  <div class="stats-grid" [style.grid-template-columns]="gridTemplateColumns">
    <div class="stat-group" *ngFor="let group of statGroups">
      <div class="stat-item">
        <p class="stat-title">{{ group.primary.title }}</p>
        <p class="stat-value">{{ group.primary.formattedValue }}</p>
      </div>
      <div class="stat-item secondary-item" *ngIf="group.secondary">
        <p class="stat-title">{{ group.secondary.title }}</p>
        <p class="stat-value">{{ group.secondary.formattedValue }}</p>
      </div>
    </div>
  </div>
</div>
